import currencyOptions from '../consts/CommonCurrency.json';

export const formatPrice = (amount, currency, fixedValue = 1) => {
    const symbol = currencyOptions[currency || 'ILS'].symbol_native;
    return symbol.concat(Number(amount).toFixed(fixedValue || 1));
};
